import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.SENTRY_DSN || process.env.sentryDsn,
  tracesSampleRate: 1.0,
})
